<script setup lang="ts">
import type { SightlineTextCell } from "@/backend/natsstubs/sightline/models";

import SightlineTruncatedText from "./SightlineTruncatedText.vue";

defineProps<{ cell: SightlineTextCell }>();
</script>

<template>
  <SightlineTruncatedText :text="cell.text" />
</template>
